import React from "react";
import PositionGenericSkeleton from "./PositionGenericSkeleton";

function PositionDetailSkeleton() {
  return (
    <>
      <PositionGenericSkeleton />
    </>
  );
}

export default PositionDetailSkeleton;
